import React, { useContext } from 'react'
import { SystemLoading } from '../store/loadingStore';
import Lottie from "lottie-react";
import LoadingAnimation from "../assets/animations/sys-load-02.json";


export default function SystemLoad() {

    const [load] = useContext(SystemLoading);
      
    return (
        <>
            {load.isShow && (
                <div
                    style={{ 
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor:'#ffffffab',
                        color: '#fff',
                        zIndex: 99999,
                        display: load.isShow ? 'flex' : 'none', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                     }}
                >
                    <div className='lottie-bg'>
                        <Lottie className='lottie-animation' animationData={LoadingAnimation} />
                        <div className='text-animation'>
                            {load?.message ? (
                                <span>{load.message}</span>
                            ) : (
                                <>
                                    <span>L</span>
                                    <span>o</span>
                                    <span>a</span>
                                    <span>d</span>
                                    <span>i</span>
                                    <span>n</span>
                                    <span>g</span>
                                </>
                            )}
                            {/* <span>.</span>
                            <span>.</span>
                            <span>.</span> */}
                        </div>
                    </div>
                </div>
            )
            }

        </>
    )
}
